import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/headers/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tools/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tools/ScrollSmoother.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tools/ScrollTop.tsx");
